import { V1Axios, V2Axios } from 'src/utils/server';

// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments.
export const APP_VERSION = '2.0.0';
export const ENABLE_REDUX_LOGGER = false;

// TODO: merge with V1Axios and replace V1Axios use with versioned V1Axios
V1Axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    let errorMessage = 'An error occurred';
    if (error.response) {
      errorMessage = error.response.data.message || error.message;
    } else if (error.request) {
      errorMessage = 'Network error';
    } else {
      errorMessage = error.message;
    }

    return Promise.reject(errorMessage);
  }
);
V2Axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    let errorMessage = 'An error occurred';
    if (error.response) {
      console.dir(error);
      console.log(error.response.status);
      console.log(error.response.headers);
      errorMessage =
        error.response.data.message ||
        error.response.data.error ||
        error.message ||
        errorMessage;
    } else if (error.request) {
      errorMessage = 'Network error';
    } else {
      errorMessage = error.message;
    }

    return Promise.reject(errorMessage);
  }
);

